import * as React from 'react';
import { Configure, Index, useSortBy, useRefinementList, useRange, useSearchBox } from 'react-instantsearch';
import { FacetId } from '../../../types.js';
import { useAlgoliaConfig } from '../../AlgoliaConfig.js';

const VirtualSortBy = ({ items  })=>{
    const parsedItems = React.useMemo(()=>items.map((item)=>({
                value: item.value,
                label: item.labelKey
            })
        )
    , [
        items
    ]);
    useSortBy({
        items: parsedItems
    });
    return null;
};
const VirtualRefinementList = ({ attribute , limit  })=>{
    useRefinementList({
        attribute,
        limit
    });
    return null;
};
const VirtualRange = ({ attribute  })=>{
    useRange({
        attribute
    });
    return null;
};
const VirtualSearchBox = ()=>{
    useSearchBox();
    return null;
};
/**
 * VirtualFacets should never render HTML
 */ const VirtualFacets = ()=>{
    const { locale , facets , sortIndices , filters , ruleContexts , facetingAfterDistinct , indexes , isMultilingualEnabled , clientQueryString ,  } = useAlgoliaConfig();
    const localeFilter = `locale:${locale.replace('-', '_')}`;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Configure, {
        clickAnalytics: true,
        facetingAfterDistinct: facetingAfterDistinct,
        filters: filters,
        ruleContexts: ruleContexts
    }), sortIndices.length > 0 ? /*#__PURE__*/ React.createElement(VirtualSortBy, {
        items: sortIndices
    }) : null, indexes && indexes.length > 0 ? indexes.map((index)=>{
        const rawQuery = new URLSearchParams(clientQueryString === null || clientQueryString === void 0 ? void 0 : clientQueryString.split('?')[1]);
        var ref;
        const query = (ref = rawQuery.get('q')) !== null && ref !== void 0 ? ref : undefined;
        return /*#__PURE__*/ React.createElement(Index, {
            indexName: index.name,
            key: index.name
        }, /*#__PURE__*/ React.createElement(Configure, {
            filters: isMultilingualEnabled ? localeFilter : undefined,
            ruleContexts: ruleContexts,
            query: query
        }));
    }) : null, sortIndices.length > 0 ? /*#__PURE__*/ React.createElement(VirtualSortBy, {
        items: sortIndices
    }) : null, /*#__PURE__*/ React.createElement(VirtualSearchBox, null), facets.map((facet)=>{
        switch(facet.id){
            case FacetId.price:
                return /*#__PURE__*/ React.createElement(VirtualRange, {
                    key: facet.attribute,
                    attribute: facet.attribute
                });
            default:
                return /*#__PURE__*/ React.createElement(VirtualRefinementList, {
                    key: facet.attribute,
                    attribute: facet.attribute,
                    limit: 100
                });
        }
    }));
};

export { VirtualFacets };
//# sourceMappingURL=VirtualFacets.js.map
